import React, { useState, useEffect } from "react";
import CustomLoader from "../../components/CustomeLoader";
import googlepay from "../../ulits/images/google-pay.svg";
import staricon from "../../ulits/images/star-img.svg";
import Accordion from 'react-bootstrap/Accordion';
import { useSelector } from "react-redux";
import { configs } from "../../config";

function AboutTestimonials() {
  const [loader, setLoading] = useState(true);
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || []; const [visibleCount, setVisibleCount] = useState(6);

  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);

  const loadMoreReviews = () => {
    setVisibleCount((prev) => prev + 6);
  };

  // Render dynamic stars based on rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={`full-${i}`} style={{ color: '#FBBC04', fontSize: '20px' }}>★</span>);
    }
    if (hasHalfStar) {
      stars.push(<span key="half" style={{ color: '#FBBC04', fontSize: '20px' }}>★</span>);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} style={{ color: '#E0E0E0', fontSize: '20px' }}>★</span>);
    }

    return <div style={{ display: 'flex', gap: '2px' }}>{stars}</div>;
  };

  const config = localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null;

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(
          `${configs.localApiUrl}/reviews?placeId=${config?.Google_PlaceId}`
        );
        const data = await res.json();

        if (data.reviews) {
          setReviews(data.reviews);
          setRating(data.rating || 0);
          setTotalReviews(data.totalReviews || data.reviews.length);
        } else {
          setReviews(data);
          setRating(data.rating || 0);
          setTotalReviews(data.totalReviews || data.length);
        }
      } catch (err) {
        console.error("Failed to load reviews:", err);
      }
    };
    fetchReviews();
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);
  return (
    <>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          {/* <div className="google-review-section about-google-review">
            <div className="container">
              <div className="heading-title">
                <h1>GOOGLE REVIEWS</h1>
              </div>
              <div className="google-review-wrapper-inner first-box">
                <div className="google-content-inner">
                  <img
                    src={googlepay}
                    alt="google-img"
                    className="google-img"
                  />
                  <p>5 stars</p>
                  <img src={staricon} alt="arrow-icon" className="star-icon" />
                  <p>234 reviews</p>
                </div>
              </div>
              <div className="google-review-wrapper-box">
                <div className="google-review-wrapper">
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="google-review-wrapper-box">
                <div className="google-review-wrapper">
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="google-review-wrapper-box">
                <div className="google-review-wrapper">
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                  <div className="google-review-box">
                    <div className="google-review-img">
                      <img
                        src={staricon}
                        alt="arrow-icon"
                        className="google-img"
                      />
                      <img
                        src={googlepay}
                        alt="google-img"
                        className="star-icon"
                      />
                    </div>
                    <div className="google-review-content">
                      <h2>1 month ago</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Justo blandit sit nunc; curae enim lectus! Elit mi
                        auctor duis ligula magnis. Congue lectus rhoncus odio
                        venenatis sem. Quam sollicitudin potenti turpis torquent
                        semper.
                      </p>
                      <h2>John Smith</h2>
                    </div>
                  </div>
                </div>
              </div>
              <button className="primary-btn-list" title="MORE GOOGLE REVIEWS">
                MORE GOOGLE REVIEWS
              </button>
            </div>
          </div> */}
          <div className="google-review-section about-google-review">
            <div className="container">
              <div className="heading-title">
                <h1>GOOGLE REVIEWS</h1>
              </div>

              {/* Top Summary Box */}
              <div className="google-review-wrapper-inner first-box">
                <div className="google-content-inner">
                  <img src={googlepay} alt="google-img" className="google-img" />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <p style={{ margin: 0 }}>{rating ? rating.toFixed(1) : '0.0'} stars</p>
                    {renderStars(rating)}
                  </div>
                  <p>{totalReviews || 0} reviews</p>
                </div>
              </div>

              {/* Reviews Grid */}

              <div className="google-review-wrapper-box">
                <div className="google-review-wrapper">

                  {reviews?.slice(0, visibleCount).map((review, index) => (
                    <div className="google-review-box" key={index}>
                      <div className="google-review-img">
                        {renderStars(review.rating || 5)}
                        <img src={googlepay} alt="google-logo" className="star-icon" />
                      </div>
                      <div className="google-review-content">
                        <h2>{review.relative_time_description}</h2>
                        <p>{review.text}</p>
                        <h2>{review.author_name}</h2>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Show button only if more reviews are available */}
              {visibleCount < reviews.length && (
                <button
                  className="primary-btn-list"
                  title="MORE GOOGLE REVIEWS"
                  onClick={loadMoreReviews}
                >
                  MORE GOOGLE REVIEWS
                </button>
              )}
            </div>
          </div>

          <div className="stm-accordion-single-unit about-faq">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              {faqList.length > 0 && (
                faqList.map((item, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>
                        {item.ans}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AboutTestimonials;
